import React, { useEffect, useState } from "react";
import styles from "./Checklist.module.css";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addChecklist, deleteChecklistTodo, fetchChecklist, fetchCompletedList } from "../../../../../../redux/slices/checklistSlice";

const Checklist = () => {
    const [activeTab, setActiveTab] = useState("active");
    const [isTodo, setIsTodo] = useState(false);

    const [todos, setTodos] = useState([
        {
            name: "Check Engine",
            values: ["Oil OK", "No leakage"]
        },
        {
            name: "Safety Check",
            values: ["Helmet worn", "Gloves worn"]
        }
    ]);

    const [todoName, setTodoName] = useState("");
    const [valueInput, setValueInput] = useState("");
    const [values, setValues] = useState([]);

    const [openIndex, setOpenIndex] = useState(null);

    const [completedData, setCompletedData] = useState([
        {
            status: "Completed",
            photo: "https://via.placeholder.com/100",
            signature: "Signed by John",
            todos: [
                {
                    name: "Check Engine",
                    values: ["Oil OK", "No leakage"]
                }
            ]
        }
    ]);

    const [searchParams] = useSearchParams();
    const uniqueProjectId = searchParams.get('project');
    const dispatch = useDispatch();


    const checklist = useSelector((state) => state.checklist.checklist);
    const completedList = useSelector((state) => state.checklist.completedList)

    useEffect(() => {

        const apiBody = {
            projectId: uniqueProjectId,
            token: localStorage.getItem("token")
        }

        dispatch(fetchChecklist(apiBody))
        dispatch(fetchCompletedList(apiBody));

    }, []);

    useEffect(() => {
        console.log("completedList:", completedList)
    }, [completedList])


    // Add value
    const handleAddValue = () => {
        if (!valueInput.trim()) return;
        setValues([...values, valueInput]);
        setValueInput("");
    };

    // Save todo
    const handleAddTodo = () => {
        if (!todoName.trim() || values.length === 0) return;

        const newTodo = {
            name: todoName,
            values: values
        };

        const apiBody = {
            projectId: uniqueProjectId,
            token: localStorage.getItem("token"),
            todos: newTodo
        }

        dispatch(addChecklist(apiBody));

        setTodos([...todos, newTodo]);

        setTodoName("");
        setValues([]);
        setIsTodo(false);
    };

    const handleDeleteTodo = (todoId) => {
        const apiBody = {
            projectId: uniqueProjectId,
            todoId,
            token: localStorage.getItem("token")
        };

        dispatch(deleteChecklistTodo(apiBody));
    };


    return (
        <div className={styles.container}>
            {/* Tabs */}
            <div className={styles.tabs}>
                <button
                    className={`${styles.tab} ${activeTab === "active" ? styles.active : ""
                        }`}
                    onClick={() => setActiveTab("active")}
                >
                    Active Checklist
                </button>

                <button
                    className={`${styles.tab} ${activeTab === "completed" ? styles.active : ""
                        }`}
                    onClick={() => setActiveTab("completed")}
                >
                    Completed Checklist
                </button>
            </div>

            {/* ACTIVE TAB */}
            {activeTab === "active" && (
                <div className={styles.tabContent}>
                    {checklist?.map((todo, index) => (
                        <div
                            key={todo._id}  //  use _id instead of index
                            className={styles.card}
                        >
                            <div
                                className={styles.cardHeader}
                                onClick={() =>
                                    setOpenIndex(openIndex === index ? null : index)
                                }
                            >
                                <h4

                                >
                                    {todo.name}
                                </h4>

                                <div className={styles.cardActions}>
                                    <span>
                                        {openIndex === index ? "▲" : "▼"}
                                    </span>

                                    <button
                                        className={styles.deleteBtn}
                                        onClick={(e) => {
                                            e.stopPropagation(); //  prevent collapse click
                                            handleDeleteTodo(todo._id);
                                        }}
                                    >
                                        ❌
                                    </button>
                                </div>
                            </div>

                            {openIndex === index && (
                                <div className={styles.valueContainer}>
                                    {todo.values.map((val, i) => (
                                        <span key={i} className={styles.valueChip}>
                                            {val}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}

                    <div className={styles.actions}>
                        <button onClick={() => setIsTodo(true)} className={styles.addBtn}>
                            + Add Todo
                        </button>
                    </div>
                </div>
            )}

            {/* COMPLETED TAB */}
            {activeTab === "completed" && (
                <div className={styles.tabContent}>
                    {completedList?.map((item, index) => (
                        <div key={index} className={styles.card}>

                            <div className={styles.header}>
                                <span className={`${styles.status} ${styles[item.status?.replace(/\s+/g, "")]}`}>
                                    {item.status.toUpperCase()}
                                </span>
                                <span className={styles.date}>
                                    {new Date(item.createdAt).toLocaleString()}
                                </span>
                            </div>

                            <hr className={styles.cardDivider} />  {/* ← add this */}

                            <p className={styles.signature}>
                                <strong>Signature:</strong> {item.signature}
                            </p>

                            <div className={styles.imageWrapper}>
                                {item.photos?.map((photo, i) => (
                                    <img key={i} src={photo.data} alt="Checklist" />
                                ))}
                            </div>

                            <p className={styles.sectionLabel}>Checklist items</p>  {/* ← add this */}

                            <div className={styles.completedTodoList}>
                                {item.todos.map((todo, i) => (
                                    <div key={i} className={styles.todoItem}>
                                        <input type="checkbox" checked={todo.checked} readOnly />
                                        <span className={todo.checked ? styles.checkedText : ""}>
                                            {todo.name}
                                        </span>
                                    </div>
                                ))}
                            </div>

                        </div>
                    ))}
                </div>
            )}

            {/* MODAL */}
            {isTodo && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modal}>
                        <h3 className={styles.modalTitle}>Add Todo</h3>

                        <input
                            placeholder="Todo Name"
                            value={todoName}
                            onChange={(e) => setTodoName(e.target.value)}
                            className={styles.valueInput}
                        />

                        <input
                            placeholder="Enter Value"
                            value={valueInput}
                            className={styles.valueInput}
                            onChange={(e) => setValueInput(e.target.value)}
                        />
                        <button onClick={handleAddValue} className={styles.addBtn}>Add</button>

                        <div className={styles.valueContainer}>
                            {values?.map((val, i) => (
                                <span key={i} className={styles.valueChip}>
                                    {val}
                                </span>
                            ))}
                        </div>

                        <div className={styles.modalActions}>
                            <button onClick={handleAddTodo} className={styles.addBtn}>Save</button>
                            <button onClick={() => setIsTodo(false)} className={styles.addBtn} >Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Checklist;